import EventSystem from "@/service/EventSystem";
import TrackingService from "@/service/Tracking";

import PostMessageService from "./PostMessage";

export type onePlusXData = {
  survey_id: string;
  question: string;
  answer: string;
};

const inViewport = false;
const postMessageService = new PostMessageService(window.top || window.parent);

const getTealiumConfig = () => {
  postMessageService.send({ message: "getTealiumConfig" });
  postMessageService.listener("getTealiumConfig", (data: any) => {
    if (data) {
      EventSystem.publish("tealium:received", data);
    }
  });
};

const getCanonical = () => {
  postMessageService.send<string>({ message: "getCanonical" }, (url: string) =>
    EventSystem.publish("canonical:received", url)
  );
};

const send1plusXDataToAdLib = (data: onePlusXData) => {
  postMessageService.send({ message: "adlib1px", data });
};

const resize = (height: number) => {
  if (window.location.hash.indexOf("amp=1") === -1) {
    // Amp calls iframe with param
    postMessageService.send({ message: "resize", data: height });
  } else {
    // Send amp resize
    postMessageService.sendAmpResize(height);
  }
  // WELT News App
  postMessageService.sendAppResize(height);
};

const destroy = () => {
  postMessageService.send({ message: "destroy" });
};

const scroll = () => {
  postMessageService.send({ message: "scrollTo" });
};

const hasScrolledListener = () => {
  postMessageService.listener("parentHasScrolled", (data: any) =>
    EventSystem.publish("parent:scroll:finished", data)
  );
};

const reportAnswerAction = () => {
  postMessageService.send({ message: "interactionEvent" });
};

const initialized = () => {
  postMessageService.send({ message: "initialized" });
  onUpdateProps((props: { inViewport: boolean }) => {
    EventSystem.publish("hyper:ping");

    if (props.inViewport && !inViewport) {
      TrackingService.getInstance().trackOnInViewport();
    }
  });
};

export default {
  getTealiumConfig,
  getCanonical,
  resize,
  destroy,
  initialized,
  scroll,
  hasScrolledListener,
  reportAnswerAction,
  send1plusXDataToAdLib,
};

/**
 * @func onUpdateProps
 * @param listener
 */
function onUpdateProps(
  listener: (props: { inViewport: boolean }, iframe: HTMLIFrameElement) => void
): void {
  postMessageService.listener("updateProps", listener);
}
